import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";
import Icons from "@/assets/icons";
import { StripePaymentMethod } from "@/services/stripePaymentServices";
import PaymentMethodCard from "./PaymentMethodCard";

interface PaymentMethodsSectionProps {
  paymentMethods: StripePaymentMethod[];
  onOptionsPress: (paymentMethod: StripePaymentMethod) => void;
  onAddPaymentMethod: () => void;
}

const PaymentMethodsSection: React.FC<PaymentMethodsSectionProps> = ({
  paymentMethods,
  onOptionsPress,
  onAddPaymentMethod,
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Payment methods</Text>

      {paymentMethods.length === 0 ? (
        <View style={styles.emptyCard}>
          <Text style={styles.emptyText}>No payment methods added</Text>
        </View>
      ) : (
        paymentMethods.map((pm) => (
          <PaymentMethodCard
            key={pm.id}
            paymentMethod={pm}
            onOptionsPress={onOptionsPress}
          />
        ))
      )}

      <TouchableOpacity style={styles.addButton} onPress={onAddPaymentMethod}>
        <Icons.PlusCircle width={24} height={24} fill={Colors.primary} />
        <Text style={styles.addButtonText}>Add payment method</Text>
      </TouchableOpacity>
    </View>
  );
};

export default PaymentMethodsSection;

const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
  },
  title: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Medium,
    color: "#161D14",
    marginBottom: 8,
  },
  emptyCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 16,
    alignItems: "center",
  },
  emptyText: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "rgba(22, 29, 20, 0.5)",
  },
  addButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    paddingVertical: 8,
  },
  addButtonText: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: Colors.primary,
  },
});
